import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/css/App.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { takePrefillFromUrl } from "./utils/appointmentPrefill";

const onLocalhost = ["localhost", "127.0.0.1", "[::1]"].includes(
  window.location.hostname,
);

Sentry.init({
  dsn: "https://9b36ada9510374fb46bc119f9d5517c1@o4512053702623232.ingest.us.sentry.io/4512053711339520",
  environment: process.env.NODE_ENV || "production",
  // A test copy on a Mac is not a customer. REACT_APP_SENTRY_LOCAL=1 turns
  // it back on.
  enabled: !onLocalhost || process.env.REACT_APP_SENTRY_LOCAL === "1",
  // The shopper's own browser, not our code: extensions, in-app browsers,
  // a dropped connection.
  ignoreErrors: [
    /runtime\.sendMessage/,
    /webkit\.messageHandlers/,
    "Network Error",
  ],
});

// Before anything reads the cart: arriving from an appointment's "Start
// order" wipes the previous customer's session first.
takePrefillFromUrl();
// An already-open checkout tab sitting on the same page only gets a #fragment
// change, which doesn't reload anything: take it and restart from the top.
window.addEventListener("hashchange", () => {
  if (takePrefillFromUrl()) window.location.replace("/");
});

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
